import { render, staticRenderFns } from "./AddReturnBill.vue?vue&type=template&id=36938b92&scoped=true"
import script from "./AddReturnBill.vue?vue&type=script&lang=js"
export * from "./AddReturnBill.vue?vue&type=script&lang=js"
import style0 from "./AddReturnBill.vue?vue&type=style&index=0&id=36938b92&prod&scoped=true&lang=css"
import style1 from "./AddReturnBill.vue?vue&type=style&index=1&id=36938b92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36938b92",
  null
  
)

export default component.exports